import { Button, Col, Divider, Form, Image, Input, Row, Select } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { EditOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { dispatchtoast } from "../../../Utils";
import dropDownImage from "../../../Assets/ChevronDown.png";

import { addAdvertisement, editAdvertisement, uploadImage } from "./AdsApi";
import { ImSpinner10 } from "react-icons/im";
function AddAdvertisements() {
  const location = useLocation();
  const fill = location.state?.fill;
  const from = location.state?.from;
  const [form] = Form.useForm();
  const formRef = useRef(form);
  const [contentData, setContentData] = useState({});
  const [imageURL, setImageURL] = useState(from === "add" ? "" : fill.image);
  const [isLoading, setIsLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const categoryField = Form.useWatch("category", form);

  console.log(from, fill);
  const handleFileUpload = useCallback(
    async (e) => {
      try {
        setUploading(true);
        const { files } = e.target;
        const response = await uploadImage(files);
        const url = response?.data?.url;
        setImageURL(url);
        setContentData({ ...contentData, image: url });
        setUploading(false);
      } catch (error) {
        setUploading(false);
        console.log({ error });
      }
    },
    [contentData],
  );

  const navigate = useNavigate();
  const AddAdvertisement = (values) => {
    console.log(values);
    const payload = {
      link: values.link,
      isActive: values.isActive,
      image: imageURL,
      title: values.title,
    };

    setIsLoading(true);

    addAdvertisement(payload)
      .then((response) => {
        if (response.success) {
          navigate("/get/advertisements_details");
          form.resetFields();
          setIsLoading(false);
        } else {
          dispatchtoast("Fields can not be empty", true);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };
  const updateAdvertisementData = (values) => {
    console.log(values);
    const payload = {
      link: values.link,
      isActive: values.isActive,

      image: imageURL,
      title: values.title,
    };

    setIsLoading(true);

    editAdvertisement(payload, `${fill?.id}`)
      .then((response) => {
        if (response.success) {
          navigate("/get/advertisements_details");
          form.resetFields();
          setIsLoading(false);
        } else {
          dispatchtoast("Fields can not be empty", true);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (fill) {
      form.setFieldsValue({
        title: fill.title,

        link: fill.link,
        isActive: fill.isActive,

        image: fill.image,
      });
    }
  }, [form, fill]);

  const lockedOptions =
    categoryField === "Free"
      ? [{ label: "False", value: false }]
      : [
          { label: "True", value: true },
          { label: "False", value: false },
        ];

  return (
    <div>
      <Divider
        orientation="left"
        style={{ border: "#cecece" }}
        className="text-base tracking-normal font-dmsans font-normal  text-gray-900"
      >
        {from === "edit" ? "Update" : "Add"} Advertisement
      </Divider>
      <Form
        className="bg-white mt-6"
        layout="vertical"
        onFinishFailed={(err) => {
          err?.errorFields?.forEach((field) => {
            field.errors?.forEach((error) => {
              dispatchtoast(error, true);
            });
          });
        }}
        onFinish={(values) =>
          from === "add"
            ? AddAdvertisement(values)
            : updateAdvertisementData(values)
        }
        form={form}
        ref={formRef}
        initialValues={
          from === "edit"
            ? contentData
            : {
                meta: [{ name: "Title", content: "" }],
                components: [{ heading: "", paragraph: [] }],
              }
        }
      >
        <Row className="grid grid-cols-1 sm:grid-cols-2  gap-4">
          <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Title
                </p>
              }
              name="title"
              rules={[
                { required: true, message: "Please enter Title" },
                { min: 4, message: "Title must be at least 4 characters" },
              ]}
            >
              <Input placeholder="e.g.,Empower Your Learning" />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Link
                </p>
              }
              name="link"
            >
              <Input placeholder="e.g.,Your go-to source for course tips, updates, and success stories." />
            </Form.Item>
          </Col>
        </Row>

        <Row className="grid grid-cols-1 sm:grid-cols-2  gap-4">
          {/* <Col>
            <Form.Item
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Active Status
                </p>
              }
              name="isActive"
              rules={[{ required: true, message: "Please select an option" }]}
            >
              <Select
                placeholder="True"
                suffixIcon={<Image src={`${dropDownImage}`} preview={false} />}
              >
                {[
                  { label: "True", value: true },
                  { label: "False", value: false },
                ].map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col> */}
        </Row>

        <Row className="grid grid-cols-1  gap-4">
          <Col>
            <Form.Item
              name="image"
              label={
                <p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">
                  Advertisement image
                </p>
              }
            >
              <div className="relative rounded-[11px] mt-5 flex justify-center items-center h-32 w-[127px] aspect-video overflow-hidden">
                {uploading ? (
                  <div className="w-[127px] h-[127px] border rounded-sm flex justify-center items-center">
                    <ImSpinner10 />
                  </div>
                ) : imageURL ? (
                  <Image
                    src={imageURL}
                    height={127}
                    width={127}
                    className="rounded-sm object-cover"
                    preview={false}
                  />
                ) : (
                  <div className="w-[127px] h-[127px] border rounded-sm"></div>
                )}

                <input
                  type="file"
                  name="photo"
                  id="upload-photo"
                  onChange={handleFileUpload}
                />
                <label for="upload-photo" className="cursor-pointer">
                  <EditOutlined className="absolute text-xs bg-red-600 top-1 right-1 rounded-full text-white w-[22px] h-[22px] flex justify-center items-center  bottom-0 opacity-80" />
                </label>
                {/* <button >Replace</button> */}
              </div>
            </Form.Item>
          </Col>
        </Row>

        <Row className="flex justify-between">
          <Form.Item>
            <Button
              onClick={() => {
                navigate("/");
              }}
              className="RemoveButtonHover cancel-button"
              size="small"
            >
              Cancel
            </Button>
          </Form.Item>

          <Form.Item>
            <Button
              className="NoButtonHover create-button"
              size="small"
              htmlType="submit"
              loading={isLoading}
            >
              {from === "edit" ? "Edit" : "Create"} Ad
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </div>
  );
}

export default AddAdvertisements;
